import { render, staticRenderFns } from "./model-customName.vue?vue&type=template&id=6b941cc8&scoped=true"
import script from "./model-customName.vue?vue&type=script&lang=js"
export * from "./model-customName.vue?vue&type=script&lang=js"
import style0 from "./model-customName.vue?vue&type=style&index=0&id=6b941cc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b941cc8",
  null
  
)

export default component.exports